module.exports = __webpack_public_path__ + "static/media/img-social2.2cc32fbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/img-social2.png
// module id = 317
// module chunks = 0